import React from 'react';
import { Button } from 'antd';
import { createMessage } from 'works/legacy/lib/message-helper';
import { useMutation, useNavigate } from '@common/hooks';
import { PERFORM_APPLICATION_ACTION } from '@applicant-flow/graphql/mutations';
import { Modal } from '@common/components';

type Props = {
  staffingRequestId: string;
  applicationId: string;
};

export function StaffingRequestWithdrawModal({
  staffingRequestId,
  applicationId,
}: Props) {
  const navigate = useNavigate();

  const [performApplicationAction, { loading }] = useMutation(
    PERFORM_APPLICATION_ACTION,
    {
      onCompleted: () => {
        createMessage('success', 'Application has been successfully updated!');
        navigate(
          `/works/supplier/staffing-request/${staffingRequestId}/withdrawn`
        );
      },
      onError: () => {
        createMessage(
          'error',
          'Failed to update application. Please try again.'
        );
      },
      refetchQueries: ['SupplierJobPageQuery'],
    }
  );

  function onWithdrawConfirm() {
    performApplicationAction({
      variables: {
        staffingRequestApplicationId: applicationId,
        input: { action: 'withdraw' },
      },
    });
  }

  function onWithdraw() {
    Modal.confirm({
      className: 'withdaw-modal',
      onOk: onWithdrawConfirm,
      okText: 'Withdraw',
      title: 'Withdraw Application',
      content: 'Are you sure you want to withdraw this application?',
    });
  }

  return (
    <Button size="large" onClick={onWithdraw} danger loading={loading}>
      Withdraw
    </Button>
  );
}
